













import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { TempletCode } from "@/common/BaseConfig";
import { IColumn } from "@/api/types.d";
@Component
export default class Columns extends Vue {
  @Prop() private dataList!: object[];

  columnItemClick(item: IColumn) {
    switch (item.templetCode) {
      case TempletCode.NEWS_NOMAR:
        this.$router.push(
          `/news-list-page?columnId=${item.id}&title=${item.name}`
        );
        break;
      case TempletCode.NOMAL_LINK:
        this.$router.push(`/iframe?title=${item.name}`);
        break;
      case TempletCode.INDEX_PLF:
        this.$router.push("/party-building");
        break;
      default:
        if (item.name == "互动留言") {
          this.$router.push("/leave-message");
        }
        break;
    }
  }
}
